export default __webpack_public_path__ + "static/media/dog-leash.b46ef455.svg";